/*********************************************************************
 * Generated by RxDjango on 2026-07-16 12:17 (UTC)                   *
 *                                                                   *
 * Based on all ContextChannel subclasses in reactive_model.channels *
 *                                                                   *
 *                       DO NOT EDIT THIS FILE                       *
 *                                                                   *
 * To rebuild it, run:                                               *
 *                                                                   *
 *     ./manage.py makefrontend [reactive_model]                     *
 *                                                                   *
 *********************************************************************/

import { ContextChannel } from '@rxdjango/react';
import type { Task } from './reactive_model.models';

const SOCKET_URL = (process.env.REACT_APP_RX_WEBSOCKET_URL ?? 'ws://localhost:8000') as string;

export class ReactiveModelChannel extends ContextChannel {

  protected endpoint: string = "/ws/reactive_model/";
  protected baseURL: string = SOCKET_URL;

  task: Task | null = null;

  protected _modelFields: Record<string, {
      anchor: string;
      model: Record<string, Record<string, string>>;
      many?: boolean;
    }> = {
      "task": {
        anchor: "reactive_model.serializers.TaskSerializer",
        model: {
          "reactive_model.serializers.TaskSerializer": { "project": "reactive_model.serializers.ProjectSerializer" },
          "reactive_model.serializers.ProjectSerializer": {  },
        },
      },
    };

  modify_project = async (name: string, delay: number) => {
    return await this.rx.callAction('modify_project', [name, delay]);
  };
}
